import React from 'react';
import { StacklineColor, useStacklineTheme } from '@stackline/ui';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

export interface LegendIndicatorProps {
  multipleLegendsProps: {
    displayName: string;
    barColor: StacklineColor;
  }[];
}

/**
 * Color bar for LegendWithMultipleElement
 */
const LegendBar = ({ color }: { color: StacklineColor }) => {
  const theme = useStacklineTheme();
  return (
    <div
      style={{
        backgroundColor: theme.colors[color],
        width: '12px',
        height: '3px',
        borderRadius: '2px'
      }}
    />
  );
};

/**
 * Indicator with a color and a label corresponding to the
 * chart the legend is for
 */

const LegendWithMultipleElement = ({ multipleLegendsProps }: LegendIndicatorProps) => {
  return (
    <Flex gap="lg">
      {multipleLegendsProps.map((legend) => {
        return (
          <Flex key={legend.displayName} alignItems="center">
            <LegendBar color={legend.barColor} />
            <Text sx={{ paddingLeft: '8px' }} variant="body2">
              {legend.displayName}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
};

export default LegendWithMultipleElement;
